import React from 'react';
import PropTypes from 'prop-types';
import { Button, Divider, Form, Icon } from 'semantic-ui-react';

import './create-entry.scss';

class CreateEntry extends React.Component {
  static getInitialState = () => ({
    name: '',
    place: '',
    customClass: '',
    src: '',
    thumb: '',
    lat: '',
    lng: '',
    description: '',
    labelId: '',
    isPublished: true,
    make: '',
    model: '',
    exposure: '',
    fnumber: '',
    iso: '',
    focalDistance: '',
    shootingDate: '',
    lensInfo: '',
    lensModel: '',
    file: null,
  });

  constructor(props) {
    super(props);
    this.state = CreateEntry.getInitialState();
  }

  changeInput = (evt) => {
    this.setState({
      [evt.target.name]: evt.target.value,
    });
  }

  handleChange = (e, {value, name}) => {
    this.setState({
      [name]: value,
    });
  }

  handleToggle = (_evt, { checked, name }) => {
    this.setState({
      [name]: checked,
    });
  }

  handleUpload = async (evt) => {  
    const nextFile = evt.target.files?.[0] || null;
    if (!nextFile) {
      return;
    }

    const nextState = {
      file: nextFile,
      src: nextFile.name,
      thumb: nextFile.name,
    };
    this.setState(nextState);

    try {
      const exif = await this.props.onReadExif(nextFile);
      if (!exif) {
        return;
      }

      this.setState((prevState) => ({
        make: prevState.make || exif.make || '',
        model: prevState.model || exif.model || '',
        exposure: prevState.exposure || (exif.exposure ?? ''),
        fnumber: prevState.fnumber || (exif.fnumber ?? ''),
        iso: prevState.iso || exif.iso || '',
        focalDistance: prevState.focalDistance || (exif.focalDistance ?? ''),
        shootingDate: prevState.shootingDate || (exif.shootingDate || ''),
        lensInfo: prevState.lensInfo || exif.lensInfo || '',
        lensModel: prevState.lensModel || exif.lensModel || '',
      }));
    } catch (_error) {
      // Non-blocking: file selection still works even if EXIF parsing fails.
    }
  }

  onSubmitForm = async (evt) => {
    evt.preventDefault()
    try {
      await this.props.onSubmit(this.state);
      this.setState(CreateEntry.getInitialState());
    } catch (_error) {
      // Keep filled values so user can correct and retry.
    }
  };

  render() {
    const { labels } = this.props;
    const options = [
      {key: 1, text: 'thumb-paysage', value: 'thumb-paysage'},
      {key: 2, text: 'thumb-portrait', value: 'thumb-portrait'}
    ];
    const options1 = labels
      .filter((label) => String(label.name).toLowerCase() !== 'all')
      .map((label) => (
        { key: Number(label.id), text: String(label.name), value: Number(label.id) }
      ));

    const uploadLabelValue = this.state.file === null ? "Select File" : this.state.file.name;

    return (
      <>
        <div className="create-entry">
        <h2 className="create-entry-title">Create new entry</h2>
          <div className="block-create-entry">
            <Form size="tiny" className="add-entry-form" encType="multipart/form-data" onSubmit={this.onSubmitForm}>
              <Form.Field>
                <label className="upload-cstm-btn" htmlFor="picture-upload">
                  {uploadLabelValue}
                </label>
                <input
                  id="picture-upload"
                  name="myupload"
                  type="file"
                  onChange={this.handleUpload}
                />
              </Form.Field>

              <Form.Group widths="equal">
                <Form.Input
                  fluid
                  placeholder="Name"
                  value={this.state.name}
                  name="name"
                  onChange={this.changeInput}
                  type="text"
                />
                <Form.Input
                  fluid
                  placeholder="Place"
                  value={this.state.place}
                  name="place"
                  onChange={this.changeInput}
                  type="text"
                />
              </Form.Group>

              <Divider horizontal>
                <Icon name='map' />
                GPS Info
              </Divider>

              <Form.Group widths="equal">
                <Form.Input
                  fluid
                  placeholder="Latitude"
                  value={this.state.lat}
                  name="lat"
                  onChange={this.changeInput}
                  type="text"
                />
                <Form.Input
                  fluid
                  placeholder="Longitude"
                  value={this.state.lng}
                  name="lng"
                  onChange={this.changeInput}
                  type="text"
                />
              </Form.Group>

              <Divider horizontal>
                <Icon name='sort' />
                Sorting
              </Divider>

              <Form.Group widths="equal">
                <Form.Select
                  fluid
                  options={options}
                  placeholder="CustomClass"
                  name="customClass"
                  value={this.state.customClass}
                  onChange={this.handleChange}
                />
                <Form.Select
                  fluid
                  options={options1}
                  placeholder="Label"
                  name="labelId"
                  value={this.state.labelId}
                  onChange={this.handleChange}
                />
              </Form.Group>

              <Form.Group widths="equal">
                <Form.Checkbox
                  label="Published"
                  name="isPublished"
                  checked={this.state.isPublished}
                  onChange={this.handleToggle}
                />
              </Form.Group>

              <Divider horizontal>
                <Icon name='photo' />
                Technical Info
              </Divider>

              <Form.Group widths="equal">
                <Form.Input
                  fluid
                  placeholder="Camera make"
                  value={this.state.make}
                  name="make"
                  onChange={this.changeInput}
                  type="text"
                />
                <Form.Input
                  fluid
                  placeholder="Camera model"
                  value={this.state.model}
                  name="model"
                  onChange={this.changeInput}
                  type="text"
                />
              </Form.Group>

              <Form.Group widths="equal">
                <Form.Input
                  fluid
                  placeholder="Exposure time"
                  value={this.state.exposure}
                  name="exposure"
                  onChange={this.changeInput}
                  type="text"
                />
                <Form.Input
                  fluid
                  placeholder="Aperture (f-number)"
                  value={this.state.fnumber}
                  name="fnumber"
                  onChange={this.changeInput}
                  type="text"
                />
              </Form.Group>

              <Form.Group widths="equal">
                <Form.Input
                  fluid
                  placeholder="ISO"
                  value={this.state.iso}
                  name="iso"
                  onChange={this.changeInput}
                  type="text"
                />
                <Form.Input
                  fluid
                  placeholder="Focal length"
                  value={this.state.focalDistance}
                  name="focalDistance"
                  onChange={this.changeInput}
                  type="text"
                />
              </Form.Group>

              <Form.Group widths="equal">
                <Form.Input
                  fluid
                  placeholder="Shooting date (ISO)"
                  value={this.state.shootingDate}
                  name="shootingDate"
                  onChange={this.changeInput}
                  type="text"
                />
                <Form.Input
                  fluid
                  placeholder="Lens model"
                  value={this.state.lensModel}
                  name="lensModel"
                  onChange={this.changeInput}
                  type="text"
                />
              </Form.Group>

              <Form.Input
                fluid
                placeholder="Lens info"
                value={this.state.lensInfo}
                name="lensInfo"
                onChange={this.changeInput}
                type="text"
              />

              <Divider horizontal>
                <Icon name='text cursor' />
                Caption
              </Divider>

              <Form.TextArea
                placeholder="Description"
                value={this.state.description}
                name="description"
                onChange={this.changeInput}
                type="text"
              />

              <Button className="cstm-btn" type="submit">Submit</Button>
            </Form>
          </div>
        </div>
      </>
    );
  }
}

CreateEntry.propTypes = {
  labels: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    }).isRequired,
  ).isRequired,
  onReadExif: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default CreateEntry;
